import { useState } from "react";
import { isInAppBrowser, isAndroid, isIOS, buildAndroidChromeIntentUrl } from "../../lib/detectInAppBrowser";

export const InAppBrowserNotice = () => {
  const [dismissed, setDismissed] = useState(false);
  const [copied, setCopied] = useState(false);

  if (dismissed || !isInAppBrowser()) return null;

  const android = isAndroid();
  const ios = isIOS();

  const openExternally = () => {
    if (android) {
      try {
        window.location.href = buildAndroidChromeIntentUrl();
      } catch (e) {}
      return;
    }
    try {
      navigator.clipboard.writeText(window.location.href);
      setCopied(true);
    } catch (e) {}
  };

  const helpText = android
    ? "Sound may not play inside this app. Tap to launch Chrome for full playback."
    : ios
    ? 'Sound may not play inside this app. Tap "···" (top right) and choose "Open in Safari" — or copy the link below.'
    : "Sound may not play inside this app. Open this page in your browser for full playback.";

  return (
    <div
      data-testid="inapp-browser-notice"
      style={{ pointerEvents: "auto" }}
      className="mx-auto mb-3 flex items-center gap-3 max-w-[min(560px,calc(100vw-24px))] rounded-full border border-amber-300/30 bg-[#1a1408]/85 backdrop-blur-md px-4 py-2.5 text-xs text-amber-100"
    >
      <span className="flex-1 leading-snug">{copied ? "Link copied — paste it in Safari/Chrome." : helpText}</span>
      {!ios || !copied ? (
        <button
          data-testid="inapp-browser-open-button"
          onClick={openExternally}
          className="shrink-0 rounded-full bg-amber-400 text-[#1a1408] font-medium px-3 py-1.5 transition-transform duration-200 hover:scale-105"
        >
          {android ? "Open in Chrome" : "Copy Link"}
        </button>
      ) : null}
      <button
        data-testid="inapp-browser-dismiss-button"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        className="shrink-0 text-amber-200/60 hover:text-amber-100 text-sm px-1"
      >
        ✕
      </button>
    </div>
  );
};
